/**
 * What a card shows (specs/006-loyalty FR-017, FR-018, FR-024; research R6).
 *
 * Derived from two signed sums and nothing else, so it can never drift from
 * the records:
 *
 *   L = lifetime stickers   (earns +, reversals −, adjustments ±)
 *   R = rewards redeemed    (redeem +1, reversal −1)
 *   E = rewards earned      = floor(max(L, 0) / 10)
 *
 *   banked  = max(0, E − R)
 *   on card = max(0, L − 10 × max(R, E))
 *   owed    = max(0, 10 × R − L)     — a shortfall left by a refund after a
 *                                      redemption; made up before anything new
 *                                      counts, and never shown to a customer
 *
 * THE CARD RESETS AT TEN BY ARITHMETIC, NOT BY A WRITE. Nothing is "moved to a
 * new card": 12 lifetime stickers simply read as one reward and 2 on the card.
 */

export const REWARD_EVERY = 10;

export interface CardState {
  banked: number;
  onCard: number;
  owed: number;
  every: number;
}

export function cardState(lifetimeStickers: number, rewardsRedeemed: number): CardState {
  const L = lifetimeStickers;
  const R = rewardsRedeemed;
  const E = Math.floor(Math.max(L, 0) / REWARD_EVERY);
  return {
    banked: Math.max(0, E - R),
    onCard: Math.max(0, L - REWARD_EVERY * Math.max(R, E)),
    owed: Math.max(0, REWARD_EVERY * R - L),
    every: REWARD_EVERY,
  };
}
